import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { updateUserData } from '../../../actions/users';
import CellphoneVerificationComponent from '../../../components/Register/steps/cellphone-verification';
import * as AuthApi from '../../../api/auth';

class CellphoneVerification extends React.Component {
  constructor(props) {
    super(props);
  }

  verify = async (body) => {
    const { data } = await AuthApi.verifyCellphone(body);

    this.props.updateUserData(data);
  }

  resend = async () => {
    try {
      const { data } = await AuthApi.sendSms();

      this.props.updateUserData({
        ...this.props.user,
        cellphone_verification_limit: data.cellphone_verification_limit,
      });

      toast.success(this.props.t('An SMS was sent to your cellphone with the verification code'));
    } catch (err) {
      const errorCode = err.response && err.response.data && err.response.data.error;

      // On a rate-limit rejection the backend still returns the fresh limit
      // state in `errors`. We must persist it (merging into the existing user
      // so UPDATE_USER_DATA's full-object replace doesn't wipe other fields),
      // otherwise the inline cooldown/block UI would never light up when the
      // limit is hit through resend(). The user-facing toast is already shown
      // by the global catchError() in src/api/index.js, so we keep swallowing
      // the error here to avoid regressing the "don't break the screen" flow.
      if (
        errorCode === 'CELLPHONE_VERIFICATION_COOLDOWN'
        || errorCode === 'CELLPHONE_VERIFICATION_BLOCKED'
      ) {
        this.props.updateUserData({
          ...this.props.user,
          cellphone_verification_limit: err.response.data.errors,
        });
      }
    }
  }

  change = async (body) => {
    try {
      const { data } = await AuthApi.correctCellphone(body);

      toast.success(this.props.t('Your cellphone number was changed and a new verification sms was sent'));

      this.props.updateUserData(data);

      // Returns whether the number actually changed, so the caller (the modal
      // wiring in components/.../cellphone-verification.jsx) can close the
      // dialog only on real success (RF05).
      return true;
    } catch (err) {
      const errorCode = err.response && err.response.data && err.response.data.error;

      if (
        errorCode === 'CELLPHONE_VERIFICATION_COOLDOWN'
        || errorCode === 'CELLPHONE_VERIFICATION_BLOCKED'
      ) {
        this.props.updateUserData({
          ...this.props.user,
          cellphone_verification_limit: err.response.data.errors,
        });

        // Rate-limited: keep the modal open so it can re-render with the new
        // cooldown/block state (RF04). We resolve to `false` instead of
        // throwing so the dialog's Formik doesn't treat it as a field error.
        return false;
      }

      throw err;
    }
  }

  render() {
    const { user } = this.props;

    return (
      <CellphoneVerificationComponent
        user={user}
        verify={this.verify}
        resend={this.resend}
        change={this.change}
      />
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

const mapDispatchToProps = dispatch => ({
  updateUserData: (data) => dispatch(updateUserData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CellphoneVerification));
